module.exports = __webpack_public_path__ + "static/media/facebookchat.a8d2b2f1.mp3";